import type { TFunction } from "i18next";

interface UserNameData {
     firstName?: string;
     lastName?: string;
}
export const getFullName = (data: UserNameData, t: TFunction) => {
     if (data?.firstName && data?.lastName) return `${data.firstName} ${data.lastName}`;
     if (data?.firstName) return data.firstName;
     if (data?.lastName) return data.lastName;
     return t("psdaCommon.common.notAvailable");
};

